<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Perfil</h3>
        </div>
      </div>
      <div class="col-md-12 text-center text-sm-left access-permission">
        <d-card class="card">
          <d-card-body>
            <loader :is-loading="loading"></loader>
            <ValidationObserver v-if="!loading" tag="form" ref="UserProfileInternalValidationForm">
              <!-- Code -->
              <d-form-row>
                <d-col md="6" class="form-group">
                  <label>Código</label>
                  <d-form-input type="text" v-model="infoAccessPermission.UserProfileInternal.Code" :disabled="true" />
                </d-col>
                <!-- Name -->
                <d-col md="6" class="form-group">
                  <label>Nome</label>
                  <ValidationProvider rules="required|min:3" v-slot="{ errors, invalid }">
                    <d-form-input
                      type="text"
                      :class="validatedUserProfileInternalForm | showValidateError(invalid)"
                      v-model="infoAccessPermission.UserProfileInternal.Name"
                      :disabled="isSeeing"
                    />
                    <div class="invalid-feedback d-block" v-if="validatedUserProfileInternalForm">
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </d-col>
              </d-form-row>
            </ValidationObserver>
            <div v-if="!loading">
              <h5 class="card-title">Módulos</h5>
              <hr />
              <ValidationObserver tag="form" ref="ControllersValidationForm">
                <d-form-row>
                  <d-col md="11" class="form-group">
                    <label for="dropControllers">Módulo</label>
                    <ValidationProvider vid="selected_controller" rules="required" v-slot="{ errors, invalid }">
                      <d-select
                        v-model="selected_controller"
                        :class="validateControllerForm | showValidateError(invalid)"
                        :value="null"
                        id="dropControllers"
                        v-bind:disabled="isSeeing"
                      >
                        <option :value="null" selected>Selecione</option>
                        <template v-for="controller in AccessControls">
                          <option
                            v-if="!IsOnSelectedControllerList(controller.Code)"
                            v-bind:key="controller.Code"
                            v-bind:value="controller.Code"
                          >
                            {{ controller.Area.Name }} - {{ controller.Description }}
                          </option>
                        </template>
                      </d-select>
                      <div class="invalid-feedback d-block" v-if="validateControllerForm">
                        {{ errors[0] }}
                      </div>
                    </ValidationProvider>
                  </d-col>

                  <d-col v-if="!isSeeing" md="1" class="form-group">
                    <b-button
                      class="btn-margin-top"
                      variant="primary"
                      @click="AddController()"
                      v-bind:disabled="isSeeing"
                    >
                      <i class="fas fa-plus"></i>
                    </b-button>
                  </d-col>
                </d-form-row>
              </ValidationObserver>
            </div>
            <div v-if="!loading">
              <b-table ref="SubTable" :items="areas" :fields="columns" thead-class="bg-s2p-gray-light" >
                <template v-slot:cell(Actions)="row">
                  <b-button
                    v-if="VerifyAreaHasControllers(row.item.Code)"
                    class="btn-expander"
                    @click="row.toggleDetails"
                  >
                    <i :class="row.detailsShowing ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                  </b-button>
                </template>
                <template #row-details="row"> 
                  <table class="table mb-0" :key="controllerTableKey">
                    <thead class="bg-s2p-gray-light">
                      <tr>
                        <th scope="col" class="border-0" v-if="!isSeeing">
                          <b-button
                            :title="GetIconTitle(row.item.IsSelect)"
                            :class="row.item.IsSelect ? 'btn-check' : 'btn-uncheck'"
                            v-b-tooltip.hover.bottom
                            @click="FilterArea(row.item)"
                          >
                            <i :class="GetIconClass(row.item.IsSelect)" />
                          </b-button>
                        </th>
                        <th v-if="CanSeeName" scope="col" class="border-0">Módulo</th>
                        <th scope="col" class="border-0">Descrição</th>
                        <th scope="col" class="border-0">Ações</th>
                        <th scope="col" class="border-0 text-right"></th>
                        <th scope="col" class="border-0 text-left" v-if="!isSeeing">
                          <b-button
                            variant="primary"
                            title="Remover selecionados"
                            v-b-tooltip.hover.bottom
                            @click="RemoveControllerIsSelect(row)"
                            v-bind:disabled="isSeeing"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </b-button>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(controller, index) in controller_list" :key="index">
                        <template
                          v-if="row.item.Code == controller.Area.Code && IsOnSelectedControllerList(controller.Code)"
                        >
                          <td v-if="!isSeeing">
                            <d-checkbox class="ml-3" v-model="controller.IsSelect"></d-checkbox>
                          </td>
                          <td v-if="CanSeeName">{{ controller.Name }}</td>
                          <td>{{ controller.Description }}</td>
                          <td class="td-with-subs">
                            <div>
                              {{ GetControllerActionsDiv(controller.Code) }}
                            </div>
                            <span>{{ GetControllerActionsDisp(controller.Code) }}</span>
                          </td>
                          <td>
                            <div class="text-right">
                              <b-button
                                :title="isSeeing ? 'Visualizar' : 'Editar'"
                                variant="outline-secondary"
                                v-b-tooltip.hover.bottom
                                @click="OpenController(controller.Id, controller.Code)"
                              >
                                <i :class="isSeeing ? 'fas fa-eye' : 'fas fa-highlighter'" />
                              </b-button>
                            </div>
                          </td>
                          <td v-if="!isSeeing">
                            <div class="text-left">
                              <b-button
                                title="Remover"
                                variant="outline-secondary"
                                v-b-tooltip.hover.bottom
                                @click="RemoveController(controller.Code, row)"
                              >
                                <i class="fas fa-trash-alt" />
                              </b-button>
                            </div>
                          </td>
                        </template>
                      </tr>
                    </tbody>
                  </table>
                </template>
              </b-table>
            </div>
          </d-card-body>
          <!-- Save Changes -->
          <d-card-footer
            v-if="
              (!isSeeing && newPage && $isAuthorize('UserProfileInternal', 'Add')) ||
                (!isSeeing && !newPage && $isAuthorize('UserProfileInternal', 'Update'))
            "
            class="border-top"
          >
            <d-button size="sm" v-on:click.stop="SaveUserProfileInternal()" class="btn-accent ml-auto d-table mr-3">
              <template v-if="!isSeeing && newPage">
                Adicionar
              </template>
              <template v-else-if="!isSeeing && !newPage">
                Salvar
              </template>
            </d-button>
          </d-card-footer>
        </d-card>
      </div>
    </div>
    <b-modal size="lg" id="mFormController" title="Ações" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <loader :is-loading="loadingModalController"></loader>
      <div v-if="!loadingModalController">
        <label>Selecione as ações que deseja incluir no módulo</label>
        <table class="table mb-0" v-if="action_list != null && action_list != undefined && action_list.length > 0">
          <thead class="bg-s2p-gray-light">
            <tr>
              <th scope="col" class="border-0">
                <d-checkbox v-model="selectAllActions" :disabled="isSeeing"></d-checkbox>
              </th>
              <th v-if="CanSeeName" scope="col" class="border-0">Ação</th>
              <th scope="col" class="border-0">Descrição</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(action, index) in action_list" :key="index">
              <td>
                <d-checkbox v-model="action.IsSelect" :disabled="isSeeing"></d-checkbox>
              </td>
              <td v-if="CanSeeName">{{ action.Name }}</td>
              <td>{{ action.Description }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button size="sm" variant="success" @click="SaveControllerActions()" v-if="!isSeeing"> Confirmar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "access-permission",
  components: {},
  data: function() {
    return {
      userProfileCode: this.$getUserInternal().UserProfileInternal.Code,
      isSeeing: this.$route.query.isSeeing == "true",
      newPage: false,
      validatedUserProfileInternalForm: false,
      validateControllerForm: false,
      loadingModal: false,
      loadingModalController: false,
      loadingArea: false,
      loadingAddUpdate: false,
      codeArea: null,
      selectAllActions: false,
      infoAccessPermission: {
        UserProfileInternal: {
          Id: this.idUserProfileInternal,
          Code: null,
          Name: null
        },
        Controllers: []
      },
      action_list: [],
      controller_list: [],
      areas: [],
      columns: [
        {
          key: "Code",
          label: "Código"
        },
        {
          key: "Name",
          label: "Área"
        },
        { key: "Actions", label: "", class: "text-right options-column" }
      ],
      controllerTableKey: 0,
      selected_controller: null,
      idUserProfileInternal: null
    };
  },
  computed: {
    AccessControls: function() {
      return this.$options.filters.orderBy(this.controller_list, ["Area.Name", "Description"]);
    },
    CanSeeName() {
      return this.userProfileCode == 6;
    },
    loading() {
      return this.loadingModal || this.loadingArea;
    }
  },
  watch: {
    selectAllActions: function(nv) {
      this.action_list.forEach((elm, index) => {
        elm.IsSelect = nv;
      });
    }
  },
  mounted() {
    if (this.$route.query.isSeeing == "true" || this.$route.query.isSeeing == true) this.isSeeing = true;
    this.idUserProfileInternal = this.$route.params.idUserProfileInternal;
    this.newPage = this.idUserProfileInternal == 0;
    this.ListArea();
    this.ListAccessControl();
    this.GetUserProfileInternal(this.idUserProfileInternal);
  },
  methods: {
    GetUserProfileInternal: function(id) {
      if (id != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetUserProfileInternal", {
            id: id
          })
          .then(response => {
            this.infoAccessPermission = response;
          })
          .catch(error => {
            this.$makeToast(undefined, "danger", "Erro ao buscar o perfil", error);
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ListArea: function() {
      this.loadingArea = true;
      this.$store
        .dispatch("ListArea", { params: { "Object.Application.Code": 2 } })
        .then(response => {
          this.areas = response.Objects;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar as áreas", error);
        })
        .finally(() => {
          this.loadingArea = false;
        });
    },
    ListAccessControl: function() {
      let data = {
        "Object.Application.Code": 2
      };
      this.$store
        .dispatch("ListAccessControl", { params: data })
        .then(response => {
          this.controller_list = response.Objects;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar os módulos", error);
        });
    },
    SaveUserProfileInternal: function() {
      this.validatedUserProfileInternalForm = true;
      this.$refs.UserProfileInternalValidationForm.validate().then(isValid => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;
          if (this.newPage) {
            // Add
            this.$store
              .dispatch("AddUserProfileInternal", this.infoAccessPermission)
              .then(() => {
                this.$makeToast("O perfil foi cadastrado corretamente na base de dados", "success", "Perfis");
                this.ListUserProfileInternal();
              })
              .catch(error => {
                this.$makeToast(undefined, "danger", "Erro ao criar o perfil", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
                this.$router.push({
                  name: "access-permissions"
                });
              });
          } else {
            // Update
            this.$store
              .dispatch("UpdateUserProfileInternal", this.infoAccessPermission)
              .then(() => {
                this.$makeToast("Suas modificações foram salvas na base de dados", "success", "Perfis");
                this.ListUserProfileInternal();
                this.$bvModal.hide("mFormUserProfileInternal");
              })
              .catch(error => {
                this.$makeToast(undefined, "danger", "Erro ao atualizar o perfil", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
                this.$router.push({
                  name: "access-permissions"
                });
              });
          }
        }
      });
    },
    IsOnSelectedControllerList: function(code) {
      let result = this.infoAccessPermission.Controllers.find(elm => {
        return elm.Code == code;
      });
      return result == undefined ? false : true;
    },
    AddController: function() {
      this.validateControllerForm = true;

      this.$refs.ControllersValidationForm.validate().then(isValid => {
        if (isValid) {
          const selected = this.selected_controller; // Controller Code
          if (selected == null) {
            return;
          }
          // Search for duplicates
          let index = this.infoAccessPermission.Controllers.map(e => {
            return e.Code;
          }).indexOf(selected);

          if (index == -1) {
            // Add if there's not duplicates
            let pos = this.controller_list
              .map(e => {
                return e.Code;
              })
              .indexOf(selected);
            let controller = this.controller_list[pos];
            this.infoAccessPermission.Controllers.push(controller);
            this.OpenController(controller.Id, controller.Code);
          } else {
            this.$refs.ControllersValidationForm.setErrors({
              selected_controller: ["Este módulo já está atribuido ao perfil"]
            });
          }
          this.validateControllerForm = false;
          this.selected_controller = null;
        }
      });
    },
    GetControllerActions: function(code) {
      let result = this.infoAccessPermission.Controllers.find(elm => {
        return elm.Code == code;
      });
      if (result != undefined) {
        return result.Actions.length;
      }
      return 0;
    },
    GetControllerActionsDiv: function(code) {
      let selecteds = this.GetControllerActions(code);
      return selecteds == 1 ? selecteds + " ação selecionada" : selecteds + " ações selecionadas";
    },
    GetControllerActionsDisp: function(code) {
      let selecteds = this.GetControllerActions(code);
      let controller = this.controller_list.find(elm => {
        return elm.Code == code;
      });
      let disp = controller != undefined ? controller.CountAccessAction - selecteds : 0;
      return disp == 1 ? disp + " ação disponível" : disp + " ações disponíveis";
    },
    RemoveController: function(code, row) {
      let index = this.infoAccessPermission.Controllers.map(e => {
        return e.Code;
      }).indexOf(code);

      if (index > -1) {
        const areaCode = this.infoAccessPermission.Controllers[index].Area.Code;

        this.infoAccessPermission.Controllers.splice(index, 1);

        if(!this.infoAccessPermission.Controllers.some(i => i.Area.Code == areaCode)){
          row.toggleDetails();
        }
      }
    },
    RemoveControllerIsSelect: function(row) {
      let selecteds = this.controller_list.filter((elm, index) => elm.IsSelect == true);
      selecteds.forEach((elm, index) => {
        this.RemoveController(elm.Code, row);
      });
    },
    GetAccessControl: function(id, code) {
      this.loadingModalController = true;
      this.$store
        .dispatch("GetAccessControl", { id: id })
        .then(response => {
          this.action_list = response.Actions;
          if (this.action_list !== null && this.action_list != undefined && this.action_list.length != 0) {
            this.controller = this.infoAccessPermission.Controllers.find(elm => {
              return elm.Code == code;
            });
            if (this.VerifyControllerHasActions()) {
              if (this.controller.Actions.length == this.action_list.length) this.selectAllActions = true;
              else {
                this.controller.Actions.forEach((elm, index) => {
                  let action = this.action_list.find(ac => {
                    return ac.Code == elm.Code;
                  });
                  if (action != undefined) action.IsSelect = true;
                });
              }
            }
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar as ações", error);
        })
        .finally(() => {
          this.loadingModalController = false;
        });
    },
    GetIconTitle: function(isSelect) {
      return isSelect != undefined && isSelect ? "Desmarcar todos" : "Marcar todos";
    },
    GetIconClass: function(isSelect) {
      return isSelect != undefined && isSelect ? "fas fa-check-square" : "border-icon fas fa-square";
    },
    FilterArea: function(area) {
      area.IsSelect = area.IsSelect == undefined || !area.IsSelect;
      this.controller_list.forEach((elm, index) => {
        if (elm.Area.Code == area.Code) {
          elm.IsSelect = area.IsSelect;
        }
      });
      this.controllerTableKey += 1;
    },
    VerifyAreaHasControllers: function(code) {
      if (
        this.infoAccessPermission.Controllers == null ||
        this.infoAccessPermission.Controllers == undefined ||
        this.infoAccessPermission.Controllers.length == 0
      )
        return false;
      let controllers = this.infoAccessPermission.Controllers.filter((elm, index) => elm.Area.Code == code);
      return controllers != null && controllers != undefined && controllers.length > 0;
    },
    OpenController: function(id, code) {
      this.action_list = [];
      this.controller = null;
      this.selectAllActions = false;
      this.GetAccessControl(id, code);
      this.$bvModal.show("mFormController");
    },
    SaveControllerActions: function() {
      this.action_list.forEach((ac, index) => {
        this.SaveRemoveAccessAction(ac.IsSelect, ac);
      });
      this.$bvModal.hide("mFormController");
    },
    VerifyControllerHasActions: function() {
      return (
        this.controller != undefined &&
        this.controller.Actions != null &&
        this.controller.Actions != undefined &&
        this.controller.Actions.length != 0
      );
    },
    SaveRemoveAccessAction: function(add, action) {
      let indexC = this.infoAccessPermission.Controllers.map(e => {
        return e.Code;
      }).indexOf(this.controller.Code);
      if (indexC > -1) {
        let indexA = this.infoAccessPermission.Controllers[indexC].Actions.map(e => {
          return e.Code;
        }).indexOf(action.Code);

        if (add && indexA == -1) {
          this.infoAccessPermission.Controllers[indexC].Actions.push(action);
        } else if (!add && indexA > -1) {
          this.infoAccessPermission.Controllers[indexC].Actions.splice(indexA, 1);
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
.access-permission {
  padding-left: 0px;
}
.btn-margin-top {
  margin-top: 30px;
}
.btn-check {
  font-size: 1.3rem;
  color: #00304d;
  border-color: #f7f9fb;
  background-color: #f7f9fb;
  box-shadow: 0;
  -webkit-box-shadow: none;
}
.btn-uncheck {
  font-size: 1.3rem;
  color: #fff;
  border-color: #f7f9fb;
  background-color: #f7f9fb;
  box-shadow: 0;
  -webkit-box-shadow: none;
}
.btn-expander {
  color: #00304d;
  border-color: #fff;
  background-color: #fff;
  box-shadow: 0;
  -webkit-box-shadow: none;
}
.border-icon {
  border-style: solid;
  border-color: lightgray;
  border-left-width: 1px;
  border-top-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 1px;
}
/deep/ .custom-control-input:disabled ~ .custom-control-label{
  color: unset;
}
/deep/ .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before{
  background-image: none;
}
/deep/ .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::after{
  border-color: unset;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/accessPermission.vue